import React, { Component } from 'react'
import { Icon } from '../../elements'
import Menu from 'antd/lib/menu'

import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'side-nav'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

export default class SideNavigation extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    collapsed: false
  }

  toggleCollapse = () => {
    this.setState(prevState => ({
      collapsed: !prevState.collapsed
    }))
  }

  renderMenuItem = ({ key, icon, label }) => (
    <Menu.Item key={key}>
      {icon && <Icon type={icon} className={bemE('icon')} />}
      {label}
    </Menu.Item>
  )

  render() {
    const { menus } = this.props
    const { collapsed } = this.state

    return (
      <div>
        <button
          type="button"
          onClick={this.toggleCollapse}
          style={{
            marginBottom: 16,
            marginTop: 16,
            marginLeft: 24
          }}
        >
          {collapsed ? <Icon type="menu-unfold-o" style={{ fontSize: '18px' }} /> : <Icon type="menu-fold-o" style={{ fontSize: '18px' }} />}
        </button>

        <Menu
          onClick={this.props.onMenuClick}
          selectedKeys={this.props.selectedKeys}
          className={COMPONENT_CSS_CLASSNAME}
          inlineCollapsed={collapsed}
          mode="inline"
        >
          {menus.map(this.renderMenuItem)}
        </Menu>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/side-navigation/index.js